type TypedWindow = Window & {
  _sensitiveStrings?: Set<string>
}

const typedWindow = window as TypedWindow
const typedParentWindow = window.parent as TypedWindow

export const getSensitiveStrings = () => {
  if (!typedWindow._sensitiveStrings) {
    return []
  }

  if (typedParentWindow._sensitiveStrings && typedWindow.parent !== typedParentWindow) {
    return [...typedParentWindow._sensitiveStrings, ...typedParentWindow._sensitiveStrings]
  }

  return [...typedWindow._sensitiveStrings]
}

export const setSensitiveStrings = (sensitiveString: string) => {
  if (!typedWindow._sensitiveStrings) {
    typedWindow._sensitiveStrings = new Set<string>()
  }

  typedWindow._sensitiveStrings.add(sensitiveString)
}
